import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { productImage } from '../data/content';
export function Hero() {
  return <header className="bg-brand-black px-4 py-6 text-center text-white sm:px-6 sm:py-7" data-id="element-78" data-mp="9kjxsrx55a59">
      <div className="mb-2 inline-flex items-center gap-1.5 rounded-full border border-brand-gold/60 bg-brand-gold/10 px-3 py-1 font-heading text-[10px] font-semibold uppercase tracking-wide text-brand-gold sm:text-[11px]" data-id="element-79" data-mp="4lqj4w64bd3i">
        <span aria-hidden="true" data-id="element-80" data-mp="x9umvc54pg3k">🥊</span>
        <span data-id="element-81" data-mp="xb5szim1qzxu">Boxing Coach Pro™ — Complete 6-in-1 System</span>
      </div>
      <h1 className="mx-auto mb-2 max-w-2xl text-3xl leading-[0.95] text-white sm:text-5xl" data-id="element-82" data-mp="sa9szg4tfxxp">
        THE COMPLETE OPERATING SYSTEM FOR PROFESSIONAL BOXING COACHES
      </h1>
      <p className="mx-auto mb-1 max-w-xl text-sm leading-snug text-white/80 sm:text-base" data-id="element-83" data-mp="3d21rlvg2wgmo">
        Stop spending hours planning boxing sessions, creating drills, and building workouts from
        scratch.
      </p>
      <p className="mx-auto mb-3 max-w-xl font-heading text-sm font-semibold leading-snug text-white sm:text-base" data-id="element-84" data-mp="3j893b0s41pjq">
        Everything is already planned, organized, and ready to use.
      </p>
      <a href="#pricing" className="mb-3 block" data-id="element-85" data-mp="39b4gcyqfxq1v">
        <img src={productImage} alt="Boxing Coach Pro complete 6-in-1 operating system box set" className="mx-auto w-full max-w-[300px] rounded-xl object-contain shadow-[0_18px_40px_rgba(0,0,0,0.45)] transition-transform duration-200 hover:scale-[1.02] sm:max-w-sm" data-id="element-86" data-mp="39cfk4yjvyxsz" />
      </a>
      <div className="mx-auto mb-3 max-w-md" data-id="element-87" data-mp="2qjv80ssep7bv">
        <CTAButton data-id="element-88" data-mp="2qkwmz8cjmdyv">🚀 YES! I WANT MY SYSTEM NOW</CTAButton>
      </div>
      <div className="flex flex-col items-center justify-center gap-1 font-heading text-[11px] font-semibold text-white/85 sm:flex-row sm:gap-4 sm:text-xs" data-id="element-89" data-mp="2viev4wiqkp5t">
        <span className="flex items-center gap-1" data-id="element-90" data-mp="2hjym2yxeimki">
          <span aria-hidden="true" data-id="element-91" data-mp="2ll0dwuoznwcg">⭐⭐⭐⭐⭐</span> 4.9/5 — Verified Coach Reviews
        </span>
        <span className="flex items-center gap-1" data-id="element-92" data-mp="s2jnvz2aw4kk">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-gold" aria-hidden="true" data-id="element-93" data-mp="s3co0h6r7vtq" />
          7-Day Money-Back Guarantee — Zero Risk
        </span>
        <span className="sr-only" data-id="element-94" data-mp="ibgm0v1jrlk8">
          <StarIcon className="h-3 w-3" data-id="element-95" data-mp="icrmolzp4d74" /> 4.9 out of 5 stars
        </span>
      </div>
    </header>;
}